export const facetValueStates = [
    'idle',
    'selected',
    'excluded',
];
